import React from "react";
import PropTypes from "prop-types";
import InnerHTML from "dangerously-set-html-content";

const ReceiptDeliveryDetails = ({
    deliveryDetailsLabel = "",
    deliveryInfo = "",
    isVisible = false,
}) =>
    isVisible ? (
        <div className="col col--12 col--sm-7 -margin-top--15">
            <section>
                <h3>{deliveryDetailsLabel}</h3>
                <div className="-type--small -margin-top--15 -user-html-content">
                    <InnerHTML html={deliveryInfo} />
                </div>
            </section>
        </div>
    ) : null;

ReceiptDeliveryDetails.propTypes = {
    deliveryDetailsLabel: PropTypes.string,
    deliveryInfo: PropTypes.string,
    isVisible: PropTypes.bool,
};

export default ReceiptDeliveryDetails;
